module.exports = __webpack_public_path__ + "img/Power & Water (Intern).301c5fbc.png";